import { render, staticRenderFns } from "./diagnosis-text-editor.vue?vue&type=template&id=6a6bc0c4&"
import script from "./diagnosis-text-editor.vue?vue&type=script&lang=js&"
export * from "./diagnosis-text-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports